<script>
  import Right from "./Right.svelte";
  import Left from "./Left.svelte";
</script>

<main>
  <table width="100%" height="100%">
    <tr>
      <td class="height" style="text-align: center; vertical-align: middle;">
        <div class="editor">
          <Left />
          <Right />
        </div>
      </td>
    </tr>
  </table>
</main>

<style>
  main {
    height: 100%;
    background-color: rgb(32, 36, 54);

    overflow: hidden;
  }

  .editor {
    margin: auto;
    width: 80%;
    height: 75%;
    background-color: rgb(54, 60, 91);
    border-radius: 10px;
    display: flex;
    overflow: hidden;
  }

  .height{

    height: 70%;

  }

</style>
